export default __webpack_public_path__ + "static/media/MY_LOCAL_SERVICES.15e00ca8.png";